"use strict";

angular.module('PatientApp').constant('Config', {
  "baseUrl": "/releases/bdacd24/",
  "apiUrl": "/api",
  "allowIndex": true,
  "distDir": "/www",
  "appname": "patient",
  "backendless": false,
  "mask_sensitive": false,
  "pendoEnabled": false,
  "languages": ["en", "es"],
  "skipExperiments": false,
  "version": "bdacd24",
  "releaseFolder": "/releases/bdacd24/",
  "rootUrl": "https://www.gopatientco.com/",
  "env": "production"
});